import { render, staticRenderFns } from "./WsFullCalendarV5.vue?vue&type=template&id=b81c6f12&"
import script from "./WsFullCalendarV5.vue?vue&type=script&lang=js&"
export * from "./WsFullCalendarV5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports